import { render, staticRenderFns } from "./infoBarComponent.vue?vue&type=template&id=ef8d7ff0&scoped=true"
import script from "./infoBarComponent.vue?vue&type=script&lang=js"
export * from "./infoBarComponent.vue?vue&type=script&lang=js"
import style0 from "./infoBarComponent.vue?vue&type=style&index=0&id=ef8d7ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8d7ff0",
  null
  
)

export default component.exports